export default __webpack_public_path__ + "static/media/safety.756654e5.svg";